import BaseTabItem from "@PegasusCore/pegasus-one-tab-item/src/script";

class TabItem extends BaseTabItem {
    initTabItem(tabItemID) {
        window.addEventListener("pegasus-tab-item-selected", (event) => {
            if (!event.detail.tabGroup.includes(tabItemID)) {
                return;
            }
            this.showTabItem = event.detail.targetID === tabItemID;
        });
        window.addEventListener("pegasus-tab-content-selected", (event) => {
            if (!event.detail.tabGroup.includes(tabItemID)) {
                return;
            }

            if (event.detail.targetID === tabItemID) {
                setTimeout(() => {
                    this.$el.scrollIntoView();
                }, 700);
            }
        });
    }
}

document.addEventListener("alpine:init", () => {
    Alpine.data("TabItem", () => new TabItem());
});
